import React from 'react';
import './ui.css';

/**
 * A labelled group of related controls.
 *
 * Replaces the pattern this app uses everywhere else — a w3-card with a
 * coloured header bar — with a small uppercase label and a hairline. The
 * separator is drawn between adjacent sections by CSS rather than by each
 * section rendering its own, so a list of them never starts or ends with a
 * stray rule.
 *
 * `action` is for the one control that belongs to the section as a whole
 * (Add, Refresh, Revert), sat on the label's line rather than above it.
 */
function Section({ action, children, className = '', label, style }) {
  return (
    <section className={`gs-section ${className}`.trim()} style={style}>
      {(label || action) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--gs-space-3)' }}>
          {label && <span className="gs-section-label">{label}</span>}
          {action && <span style={{ marginLeft: 'auto' }}>{action}</span>}
        </div>
      )}
      <div className="gs-section-body">{children}</div>
    </section>
  );
}

export default Section;
